import { useAppSelector } from '../../hooks';
import { RootState } from '../../store';

export const useAppConfig = () =>
  useAppSelector((state: RootState) => state.appConfigSlice);
